module.exports = __webpack_public_path__ + "static/media/manitas.37dcc38b.png";